/**
 * Deep merge namespaces (app overrides system).
 * @param {Record<string, unknown>} base
 * @param {Record<string, unknown>} override
 * @returns {Record<string, unknown>}
 */
export function mergeNamespaces(base, override) {
  const result = { ...base };
  for (const [key, value] of Object.entries(override)) {
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      result[key] &&
      typeof result[key] === "object" &&
      !Array.isArray(result[key])
    ) {
      result[key] = mergeNamespaces(
        /** @type {Record<string, unknown>} */ (result[key]),
        /** @type {Record<string, unknown>} */ (value),
      );
    } else {
      result[key] = value;
    }
  }
  return result;
}
